import { render, staticRenderFns } from "./ModalCadastroRegistraSaida.vue?vue&type=template&id=9afceac6"
import script from "./ModalCadastroRegistraSaida.vue?vue&type=script&lang=js"
export * from "./ModalCadastroRegistraSaida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports